import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Module1 from "../pages/module1/page";
import Module2 from "../pages/module2/page";
import Module3 from "../pages/module3/page";
import Module4 from "../pages/module4/page";
import Module5 from '../pages/module5/page';

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />
  },
  {
    path: "/module1", 
    element: <Module1 />
  },
  {
    path: "/module2",
    element: <Module2 />
  },
  {
    path: "/module3",
    element: <Module3 />
  },
  {
    path: "/module4",
    element: <Module4 />
  },
  {
    path: "/module5",
    element: <Module5 />
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
